import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Validation from './pages/Validation';
import AuthPage from './pages/AuthPage';

function Home() {
  return <h2 className="mt-4">Home Page</h2>;
}

function About() {
  return <h2 className="mt-4">About Page</h2>;
}

function App() {
  return (
    <>
      <Navbar />
      <main className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/validation" element={<Validation />} /> {/* <-- new route */}

        </Routes>
      </main>
    </>
  );
}

export default App;
